module.exports = __webpack_public_path__ + "37d7395f4e85e7e13c09c2396b32f994.svg";